




































	import Vue from "vue"
	import {mapGetters, mapState} from "vuex"
	import Game from "@/components/Game.vue";
	import HeroesList from "@/components/HeroesList.vue";

  // eslint-disable-next-line no-unused-vars
  import {Player} from "@/types/player";
	export default Vue.extend({
		name: 'Upgrading',
		components: {
			Game: Game,
			HeroesList: HeroesList
		},
		computed: {
			...mapState(['activeGameIndex', 'numGames', 'players']),
			...mapGetters(['activeGame'])
		},
    data () {
      return {
        enteringHP: false,
        hps: []
      }
    },
		methods: {
			weWon () {
        this.hps = this.players.map((player : Player) => {
          return player.currentHP
        })
        this.enteringHP = true
			},
      enterHP () {
        const hps = this.hps.map((hp : any) => {
          return parseInt(hp)
        })
        for (let i = 0; i < hps.length; i++) {
          const hp = hps[i]
          if (isNaN(hp) || hp < 0) {
            alert('HP values must be 0 or higher')
            return
          }
        }
        this.$store.dispatch('gameWon', hps)
      },
			weLost () {
        if (!confirm('Confirm defeat?')) {
          return
        }
				this.$store.dispatch('gameLost')
			}
		}
	})
